import Image from 'next/image';
import { Heading } from '../../../components/Heading/Heading';
import { Text } from '../../../components/Text/Text';
import hero from '../../../../public/images/million-pound-challenge/hero.png';

export const HeroSection = () => (
  <section className="flex flex-col items-center gap-6 px-4 text-center">
    <div className="relative size-63.75">
      <Image
        src={hero}
        alt="Million Pound Challenge"
        fill
        sizes="255px"
        className="object-contain"
        priority
      />
    </div>
    <Heading variant="xl" as="h1" className="text-trench m-0 max-w-2xl">
      Proud to be part of something bigger than fishing.
    </Heading>
    <div className="text-abyss flex max-w-2xl flex-col gap-4">
      <Text variant="md" className="m-0">
        This summer, Fishbrain joined the ASA&apos;s Million Pound Challenge, an industry-wide
        initiative to remove 1 million pounds of trash from our waterways. 32 companies came
        together for cleanups this season, pulling nearly 10,000 pounds out of the places we all
        love to fish.
      </Text>
      <Text variant="md" className="m-0">
        That&apos;s just the start. The million pound goal is a multi-year commitment, and this
        summer was the kickoff. We&apos;re in it for the long haul.
      </Text>
      <Text variant="md" className="m-0">
        Clean water isn&apos;t a nice-to-have. It&apos;s the whole point.
      </Text>
    </div>
  </section>
);
